import { Actions } from "./reminderConstants";
import produce from "immer";

const initialBulkUpdate = {
  loading: false,
  operationResult: null,
}

const initialState = {
  producerCodes1List: [],
  producerCodes2List: [],
  producerCodes1Loading: false,
  producerCodes2Loading: false,
  reminderProfilesLoading: false,
  reminderProfiles: [],
  data: [],
  searchValues: [],
  loading: false,
  selectedRows: [],
  selected: null,
  selectedLoading: false,
  activeTab: "1",
  assignees: [],
  assigneesLoading: false,
  bulkAssign: { ...initialBulkUpdate },
  bulkProducerUpdate: {
    1: { ...initialBulkUpdate },
    2: { ...initialBulkUpdate },
  },
  bulkProducerTargets: {
    1: [],
    2: [],
  },
  bulkProducerTargetsLoading: {
    1: false,
    2: false,
  },
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.LIST_REMINDER_PROFILES:
        draft.reminderProfilesLoading = true;
        return draft;
      case Actions.LIST_REMINDER_PROFILES_SUCCEEDED:
        draft.reminderProfilesLoading = false;
        if (action.payload.Operation.Outcome !== "Success") {
          draft.operationResult = action.payload.Operation;
        } else {
          draft.operationResult = null;
          draft.reminderProfiles = action.payload.Data;
        }
        return draft;
      case Actions.SET_SEARCH_VALUES:
        draft.searchValues = action.payload.searchValues;
        return draft;
      case Actions.CLEAR_REMINDER_PROFILES:
        draft.reminderProfiles = [];
        return draft;
      case Actions.LIST__REMINDERS:
        draft.loading = true;
        if (action.returnProducerLists === true) {
          draft.producerCodes1Loading = true;
          draft.producerCodes2Loading = true;
        }
        return draft;
      case Actions.LIST__REMINDERS_SUCCEEDED:
        draft.loading = false;
        if (action.payload.Operation.Outcome !== "Success") {
          draft.operationResult = action.payload.Operation;
        } else {
          draft.operationResult = null;
          draft.data = action.payload.Data;
          if (action.payload.returnProducerLists === true) {
            draft.producerCodes1Loading = false;
            draft.producerCodes2Loading = false;
            draft.producerCodes1List = action.payload.ProducerCodes1;
            draft.producerCodes2List = action.payload.ProducerCodes2;
          }
        }
        return draft;
      case Actions.SET_SELECTED_ROWS:
        draft.selectedRows = action.payload.selectedRows;
        return draft;
      case Actions.CLEAR_SELECTED_ROWS:
        draft.selectedRows = [];
        return draft;
      case Actions.READ_REMINDER_DETAILS:
        draft.selectedLoading = true;
        return draft;
      case Actions.READ_REMINDER_DETAILS_SUCCEEDED:
        draft.selectedLoading = false;
        if (action.payload.Operation.Outcome !== "Success") {
          draft.operationResult = action.payload.Operation;
        } else {
          draft.operationResult = null;
          draft.selected = action.payload.Data;
        }
        return draft;
      case Actions.SET_ACTIVE_TAB:
        draft.activeTab = action.payload.tabKey;
        return draft;
      case Actions.CLEAR_REMINDER_LIST:
        draft.data = [];
        draft.loading = false;
        draft.selectedRows = [];
        draft.selected = null;
        draft.activeTab = "1";
        draft.selectedLoading = false;
        draft.searchValues = [];
        return draft;
      case Actions.CLEAR_OPERATION_RESULT:
        draft.operationResult = null;
        return draft;
      case Actions.LIST_ASSIGNEES:
        draft.assigneesLoading = true;
        return draft;
      case Actions.LIST_ASSIGNEES_SUCCEEDED:
        draft.assigneesLoading = false;
        if (action.payload.Operation.Outcome === "Success") {
          draft.assignees = action.payload.Data ?? [];
        }
        return draft;
      case Actions.BULK_ASSIGN_REMINDERS:
        draft.bulkAssign.loading = true;
        draft.bulkAssign.operationResult = null;
        return draft;
      case Actions.BULK_ASSIGN_REMINDERS_SUCCEEDED:
        draft.bulkAssign.loading = false;
        draft.bulkAssign.operationResult = action.payload.Operation;
        return draft;
      case Actions.CLEAR_BULK_ASSIGN_DATA:
        draft.bulkAssign = initialBulkUpdate;
        return draft;
      case Actions.LIST_PRODUCER_CODES:
        draft.bulkProducerTargetsLoading[action.payload.producerSlot] = true;
        return;
      case Actions.LIST_PRODUCER_CODES_SUCCEEDED:
        draft.bulkProducerTargetsLoading[action.meta.producerSlot] = false;
        if (action.payload.Operation.Outcome === "Success") {
          draft.bulkProducerTargets[action.meta.producerSlot] = action.payload.Data ?? [];
        }
        return draft;
      case Actions.BULK_UPDATE_PRODUCER_CODE:
        draft.bulkProducerUpdate[action.payload.producerSlot].loading = true;
        draft.bulkProducerUpdate[action.payload.producerSlot].operationResult = null;
        return;
      case Actions.BULK_UPDATE_PRODUCER_CODE_SUCCEEDED:
        draft.bulkProducerUpdate[action.meta.producerSlot].loading = false;
        draft.bulkProducerUpdate[action.meta.producerSlot].operationResult = action.payload.Operation;
        return;
      case Actions.CLEAR_BULK_PRODUCER_UPDATE_DATA:
        draft.bulkProducerUpdate[action.payload.producerSlot] = {
          loading: false,
          operationResult: null,
        };
        return draft;
      case Actions.CLEAR_BULK_PRODUCER_TARGETS:
        draft.bulkProducerTargets[action.payload.producerSlot] = [];
        draft.bulkProducerTargetsLoading[action.payload.producerSlot] = false;
        return draft;
      default:
        return state;
    }
  });
};
